export const checkoutInfoEditLayoutStyle = {
  mt: '-1px',
};

const layerStyles = {
  checkoutInfoEditLayoutStyle,
};

export default layerStyles;
